
import { EMPTY_AUDIT_LOG_SEARCH_CRITERIA } from "domain/entity/AuditLog/AuditLogSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { useAuditLogMaintenanceVM } from "presentation/hook/AuditLog/useAuditLogMaintenanceVM";
import { useAuditLogMaintenanceTracked } from "presentation/store/AuditLog/AuditLogMaintenanceProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import AuditLogDetailPanel from "./AuditLogDetailPanel";
import { AuditLogSearchPanel } from "./AuditLogSearchPanel";
import AuditLogTablePanel from "./AuditLogTablePanel";
import AuditLogTitleBar from "./AuditLogTitleBar";

export const AuditLogMaintenance: React.FC = () => {
    const [auditLogState] = useAuditLogMaintenanceTracked();
    const { isShowSearchPanel, isShowDetailPanel } = auditLogState;
    const auditLogVM = useAuditLogMaintenanceVM();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const initialScreen = async () => {
            auditLogVM.setIsSearchLoading(true);
            let newSearchCriteria = { ...EMPTY_AUDIT_LOG_SEARCH_CRITERIA }
            newSearchCriteria = {
                ...newSearchCriteria,
                updatedDateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                updatedDateTo: moment().endOf("day").toDate(),
            };
            await Promise.allSettled([
                auditLogVM.loadDropdownOption(),
                auditLogVM.onSearch(newSearchCriteria),
            ]);
        }
        initialScreen().then((data) => {
            setIsLoading(false);
            auditLogVM.setIsSearchLoading(false);
        }).catch(() => {
            auditLogVM.setIsSearchLoading(false);
        });

    }, [auditLogVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${(isShowSearchPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            {isShowDetailPanel && <AuditLogDetailPanel />}
            {!isShowDetailPanel && <>
                <AuditLogTitleBar />
                <SliderPanel
                    isOpen={true}
                    leftSectionWidth={isShowSearchPanel ? '30%' : '0%'}
                    rightSectionWidth={isShowSearchPanel ? '70%' : '100%'}
                    draggable={true}
                    leftChildren={<AuditLogSearchPanel />}
                    rightChildren={<AuditLogTablePanel />} />
            </>}
        </div>
    </>
}